import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { GenericEventModel } from '@atumverse/core-models';
import { EventsService, FinfraMenuService } from '@atumverse/core-services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'finfra-function',
  templateUrl: './function.component.html',
  styleUrls: ['./function.component.scss']
})
export class FunctionComponent implements OnInit, OnDestroy {
  public functionId: string | undefined;
  public applicationId: string | undefined;

  public eventsSubscription: Subscription | undefined;

  private ajsfFormGroup: FormGroup | undefined;

  public formData: any = {};

  constructor(
    private finfraMenuService: FinfraMenuService,
    private eventsService: EventsService,
  ) {
    this.eventsSubscription = this.eventsService.listenEvents().subscribe(this.onEvent.bind(this));
  }

  ngOnInit(): void {
    this.functionId = this.finfraMenuService.currentMenu?.id;
    this.applicationId = this.finfraMenuService.currentApplicationId;
  }

  ngOnDestroy(): void {
    if (this.eventsSubscription) {
      this.eventsSubscription.unsubscribe();
    }

    this.functionId = undefined;
    this.applicationId = undefined;
  }

  public onEvent(event: GenericEventModel): void {
    if (event.eventSource === 'finfra-menu' && event.eventName === 'application-set') {
      this.functionId = this.finfraMenuService.currentMenu?.id;
      this.applicationId = this.finfraMenuService.currentApplicationId;
    }

    if (event.eventSource === 'finfra-ajsf' && event.eventName === 'finfra-ajsf-form-group' && event.formName === this.functionId + 'Form') {
      this.ajsfFormGroup = (event.formControl as FormGroup);
    }
  }
}
